import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';

const MentorGuard = ({ children }) => {
  const { isAuthenticated, isMentor, isAdmin, isOps } = useAuth();

  if (!isAuthenticated) {
    return <Redirect to="/login" />;
  }
  if (!isMentor) {
    if (isAdmin || isOps) {
      return <Redirect to="/soon" />;
    }
    return <Redirect to="/404" />;
  } else {
    return <>{children}</>;
  }
};

MentorGuard.propTypes = {
  children: PropTypes.node
};

export default MentorGuard;
